h<template>
  <div id="misc">
    <full-view-dialog
      ref="fullViewDialog"
    />

    <h1>Gestión de Citas - Happy Memories</h1>
    <p>Para iniciar, selecciona una opción del menú o una tarjeta.</p>
    <v-row v-if="items">
      <home-card
        v-for="item in items"
        :key="item.bookingId"
        :booking="item"
        @OnViewEvent="fullViewDialog.ShowDialog(item.bookingKey)"
      >
      </home-card>
    </v-row>
  </div>
</template>

<script>
import {
  ref, onMounted,
} from '@vue/composition-api'
import HomeCard from './components/HomeCard.vue'
import store from '@/store'
import daysFromToday from '@/scripts/helpers/daysFromToday'
import FullViewDialog from '@/views/bookings/components/FullViewDialog.vue'

export default {
  components: { HomeCard, FullViewDialog },
  setup() {
    const items = ref([])
    const today = daysFromToday(0).toISOString().split('T')[0]
    const nextYear = daysFromToday(365).toISOString().split('T')[0]

    /** FulViewDialog* *********************** */
    const fullViewDialog = ref()

    const FetchItems = () => {
      store
        .dispatch('bookings/apiCall', {
          mode: 'select',
          request: {
            srt: 'startDate',
            pg: 0,
            ippg: 12,
            all: process.env.VUE_APP_API_ALL,
            eventStatus: '1,2,3,4',
            from: today,
            to: nextYear,
          },
        })
        .then(response => {
          if (response.success) {
            items.value = response.data.items
          }
        })
    }

    onMounted(() => {
      FetchItems()
    })

    return {
      fullViewDialog,
      items,
    }
  },
}
</script>
